export default {
  state: {
    category: {},
  },
  mutations: {
    setCategory(state, payload) {
      state.category = payload;
    },
  },
  actions: {
    setCategory(context, payload) {
      context.commit('setCategory', payload);
    },
  },
  getters: {
    getCategory(state) {
      return state.category;
    }
  },
}